import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Eye, EyeOff, Loader } from 'lucide-react'
import { useStaffAuthStore } from '../../store/staffAuthStore'
import toast from 'react-hot-toast'

export default function StaffLogin() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPw, setShowPw] = useState(false)
    const [loading, setLoading] = useState(false)
    const { login } = useStaffAuthStore()
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!email || !password) { toast.error('Fill in all fields'); return }
        setLoading(true)
        try {
            const profile = await login(email, password)
            toast.success(`Welcome back, ${profile?.name || 'Admin'}!`)
            navigate('/staff/dashboard')
        } catch (err) {
            toast.error(err.message || 'Login failed')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
            <div className="w-full max-w-sm">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 overflow-hidden bg-slate-800">
                        <img
                            src="/abha-logo.png"
                            alt="AbhaFlow"
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <h1 className="text-2xl font-bold text-white">AbhaFlow</h1>
                    <p className="text-slate-400 text-sm mt-1">Admin & Staff Portal</p>
                </div>

                {/* Card */}
                <div className="bg-slate-900 rounded-2xl border border-white/5 p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="text-xs font-medium text-slate-400 block mb-1.5">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="admin@abhaev.store"
                                className="w-full bg-slate-800 border border-white/8 rounded-xl px-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition"
                                autoFocus
                            />
                        </div>

                        <div>
                            <label className="text-xs font-medium text-slate-400 block mb-1.5">Password</label>
                            <div className="relative">
                                <input
                                    type={showPw ? 'text' : 'password'}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    className="w-full bg-slate-800 border border-white/8 rounded-xl px-4 py-3 pr-11 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPw(!showPw)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
                                >
                                    {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium py-3 rounded-xl text-sm transition flex items-center justify-center gap-2"
                        >
                            {loading ? <><Loader size={16} className="animate-spin" /> Signing in...</> : 'Sign In'}
                        </button>
                    </form>
                </div>

                <p className="text-center text-xs text-slate-600 mt-6">
                    Abha Enterprise · Jhargram, West Bengal
                </p>
            </div>
        </div>
    )
}
